import { render, staticRenderFns } from "./ReceiveView.vue?vue&type=template&id=0e4d88b8&scoped=true&"
import script from "./ReceiveView.vue?vue&type=script&lang=js&"
export * from "./ReceiveView.vue?vue&type=script&lang=js&"
import style0 from "./ReceiveView.vue?vue&type=style&index=0&id=0e4d88b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4d88b8",
  null
  
)

export default component.exports